import Vue from 'vue'
import { axios } from '@/utils/request';
import signMd5Utils from '@/utils/encryption/sign-md5-utils'

//get
export function getAction(url,parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};
    return axios({
        url: url,
        method: 'get',
        params: parameter,
        headers: signHeader
    })
}

//post
export function postAction(url,parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};
    return axios({
        url: url,
        method:'post' ,
        data: parameter,
        headers: signHeader
    })
}

//post method= {post | put}
export function httpAction(url,parameter,method) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};
    return axios({
        url: url,
        method:method ,
        data: parameter,
        signHeader
    })
}

//put
export function putAction(url,parameter) {
    return axios({
        url: url,
        method:'put',
        data: parameter
    })
}

//deleteAction
export function deleteAction(url,parameter) {
    return axios({
        url: url,
        method: 'delete',
        params: parameter
    })
}

/**
 * 下载文件 用于excel导出
 */
export function downFile(url,parameter){
    return axios({
        url: url,
        params: parameter,
        method:'get' ,
        responseType: 'blob'
    })
}

/**
 * 文件上传 用于富文本上传图片
 * @param url
 * @param parameter
 * @returns {*}
 */
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'post' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar,subStr) {
    if(!subStr) subStr = 'http'
    try {
        if(avatar && avatar.startsWith(subStr)){
            return avatar;
        }else{
            if(avatar &&　avatar.length>0 && avatar.indexOf('[')==-1){
                return window._CONFIG['staticDomainURL'] + "/" + avatar;
            }
        }
    }catch(err){
        return;
    }
}



